import React from 'react';
import { View } from 'react-native';
import MessagesList from './MessagesList';
import NotesList from './NotesList';

export type DesktopRecentActivityScreenOwnProps = {
    profileId: string;
};

export type DesktopRecentActivityScreenProps = DesktopRecentActivityScreenOwnProps;

const DesktopRecentActivityScreen: React.FC<DesktopRecentActivityScreenProps> = (props) => {
    return (
        <View style={{ flex: 1, alignSelf: 'stretch', flexDirection: 'row' }}>
            <MessagesList profileId={props.profileId} />
            <View style={{ width: 8 }} />
            <NotesList profileId={props.profileId} />
        </View>
    );
};

export default React.memo(DesktopRecentActivityScreen);
